import './InfoIconWithModal.less';

import React from 'react';
import clsx from 'clsx';
import InfoCircleIcon from 'nike-ui/src/icons/svg/info-circle-icon-sv.svg';
import PopupNg from '@/ui/PopupNg';

const InfoIconWithModal = ({ reason, showArrowIcon }) => {
    const onOpen = e => {
        const { top } = e.target.getBoundingClientRect();
        PopupNg.dispatcher.open('returnReason/popup', { reason, top, showArrowIcon });
        e.stopPropagation();
    };

    return reason ? (
        <>
            <button
                onClick={onOpen}
                className={clsx('p-rel mx-8 fs-0 py-5 px-5 info-icon-modal', { 'mr-50': showArrowIcon })}
            >
                <InfoCircleIcon />
            </button>
        </>
    ) : null;
};

export default InfoIconWithModal;
